import { useNavigation } from 'expo-router';
import React, { useEffect, useMemo, useState } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { PointsProgress } from '@fhs/loyalty/src/components';
import { isWeb } from '@fhs/utils';

import { useLoyaltyLegacyStates } from '../../hooks/use-loyalty-legacy-states';
import { useRewardTiers } from '../../queries/loyalty.queries';

interface Props {
  style?: StyleProp<ViewStyle>;
  loading?: boolean;
}

export function RewardsPointsProgress({ style, loading }: Props) {
  const { data: rewardTiers, isLoading: isLoadingRewardTiers } = useRewardTiers();
  const { loyaltyUser, loyaltyUserReady } = useLoyaltyLegacyStates();
  const [enableAnimation, setEnableAnimation] = useState(isWeb);
  const navigation = useNavigation();
  const isLoading = loading || !loyaltyUserReady || isLoadingRewardTiers;

  useEffect(() => {
    const unsubscribe = navigation.addListener('transitionEnd' as any, () => {
      setEnableAnimation(true);
    });
    return unsubscribe;
  }, [navigation]);

  const tiers = useMemo(() => {
    const pointsProgressTiers =
      rewardTiers?.map(rewardTier => ({
        id: rewardTier.id,
        value: rewardTier.points,
      })) ?? [];
    return pointsProgressTiers.length > 0
      ? [
          {
            id: '0',
            value: 0,
          },

          ...pointsProgressTiers,
        ]
      : [];
  }, [rewardTiers]);

  return (
    <PointsProgress
      points={loyaltyUser?.points}
      loading={isLoading}
      enableAnimation={enableAnimation}
      tiers={tiers}
      style={style}
    />
  );
}
